export const BI_API_CONSTANT = {
    biEndpoint: 'biEndpoint',
};
